import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { blogImageSrc, COURSE_PLACEHOLDER } from "../../../api/blogImage";

function CategoriesSection({ data }) {
  const sliderRef = useRef(null);
  const categories = Array.isArray(data) ? data : [];

  const scroll = (dir) => {
    const slider = sliderRef.current;
    if (!slider) return;

    const card = slider.querySelector(".cat-slide");
    if (!card) return;

    const scrollAmount = card.offsetWidth + 24;

    slider.scrollBy({
      left: dir === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <section className="cat-section">
      <div className="cat-slider-wrapper">

        <div className="site-title text-center mb-60">
          <h2>
            Explore Top <span className="text-gradient">Categories</span>
          </h2>
          <p>Choose from a wide range of learning paths crafted by experts.</p>
        </div>

        {categories.length === 0 ? (
          <p className="text-center">No categories available right now.</p>
        ) : (
          <>
            <button className="cat-arrow left" onClick={() => scroll("left")}>
              ‹
            </button>

            <div className="cat-slider" ref={sliderRef}>
              {categories.map((cat) => (
                <div className="cat-slide" key={cat.slug || cat.title}>
                  <Link to={cat.link || "/courses"} className="category-box">
                    <img
                      src={blogImageSrc(cat.icon, COURSE_PLACEHOLDER)}
                      alt={cat.title}
                      onError={(event) => {
                        event.target.onerror = null;
                        event.target.src = blogImageSrc(null, COURSE_PLACEHOLDER);
                      }}
                    />
                    <h4>{cat.title}</h4>
                    <p>{cat.courses}</p>
                  </Link>
                </div>
              ))}
            </div>

            <button className="cat-arrow right" onClick={() => scroll("right")}>
              ›
            </button>
          </>
        )}

      </div>
    </section>
  );
}

export default CategoriesSection;
